import { render, staticRenderFns } from "./SeleccionarAsientosSga.vue?vue&type=template&id=0aeed812"
import script from "./SeleccionarAsientosSga.vue?vue&type=script&lang=js"
export * from "./SeleccionarAsientosSga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports